import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeZone'
})
export class TimeZonePipe implements PipeTransform {

  transform(value: string): string {
    
    switch (value) {
      case 'Hawaiian Standard Time':
        return 'Hawaiian Standard Time';
      case 'Samoa Standard Time':
        return 'Samoa Standard Time';
      case 'Mountain Standard Time':
        return 'Mountain Standard Time';
      case 'Alaskan Standard Time':
        return 'Alaskan Standard Time';
      case 'West Pacific Standard Time':
        return 'West Pacific Standard Time';
      case 'UTC+12':
        return 'UTC+12';
      case 'US Mountain Standard Time':
        return 'Mountain Standard Time (Arizona)';
      case 'Pacific Standard Time':
        return 'Pacific Standard Time';
      case 'Eastern Standard Time':
        return 'Eastern Standard Time';
      case 'Atlantic Standard Time':
        return 'Atlantic Standard Time';
      case 'Central Standard Time':
        return 'Central Standard Time';  
      default:
        return value;
      
    }
  }

}
